import React, { useState } from "react";
import { Mail, Send } from "lucide-react";
import { useI18n } from "@/lib/i18n";
import { api, formatApiError } from "@/lib/api";
import { getGuestName, setGuestName } from "@/lib/guest";
import { toast } from "sonner";

export default function Mensajes() {
  const { t } = useI18n();
  const [name, setName] = useState(getGuestName());
  const [msg, setMsg] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!msg.trim()) { toast.error(t.common.messageRequired); return; }
    setLoading(true);
    try {
      await api.post("/messages", { name: name || null, message: msg.trim() });
      if (name) setGuestName(name);
      setSent(true);
      toast.success(t.asistencia.thanksMessage);
    } catch (err) { toast.error(formatApiError(err)); }
    finally { setLoading(false); }
  };

  return (
    <main data-testid="mensajes-page" className="section">
      <h1 className="page-title font-script">{t.mensajes.title}</h1>
      <p className="text-center text-[color:var(--ink-soft)] max-w-xl mx-auto mb-8">
        {t.mensajes.subtitle}
      </p>

      {sent ? (
        <div className="max-w-2xl mx-auto">
          <div className="s-card s-card-pad text-center" data-testid="message-thanks">
            <Mail className="mx-auto text-[color:var(--olive)] mb-3" size={42} />
            <h3 className="font-script text-3xl text-[color:var(--ink-wine)] mb-2">{t.asistencia.thanksMessage}</h3>
            <button
              onClick={() => { setSent(false); setMsg(""); }}
              className="btn-outline mt-4"
              data-testid="message-another"
            >
              {t.mensajes.another}
            </button>
          </div>
        </div>
      ) : (
        <form onSubmit={submit} className="max-w-2xl mx-auto" data-testid="message-form">
          <div className="s-card s-card-pad">
            <div className="flex items-center gap-2 mb-3 text-[color:var(--ink-wine)]">
              <Mail size={18} />
              <span className="font-script-alt text-2xl">{t.asistencia.messageTitle}</span>
            </div>
            <p className="text-sm text-[color:var(--ink-soft)] mb-4">{t.asistencia.messageDesc}</p>

            <div className="mb-4">
              <label className="label">{t.asistencia.yourName}</label>
              <input
                data-testid="message-name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                className="field"
                placeholder={t.asistencia.yourNamePh}
              />
            </div>

            <div>
              <label className="label">{t.asistencia.messageTitle}</label>
              <textarea
                data-testid="message-text"
                value={msg}
                onChange={(e) => setMsg(e.target.value)}
                rows={8}
                className="field"
                placeholder={t.asistencia.messagePh}
                required
              />
            </div>
          </div>

          <button type="submit" disabled={loading} className="btn-primary mt-5" data-testid="message-submit">
            <Send size={16} /> {loading ? "..." : t.asistencia.submitMessage}
          </button>
        </form>
      )}
    </main>
  );
}
